<img
  *ngIf="(company$ | async).logo"
  [ngClass]="parentClasses"
  [ngStyle]="{
    'border-radius': '3px',
    height: !height() && width() ? 'auto' : 'null',
    width: height() && !width() ? 'auto' : 'null'
  }"
  [appWaitForImage]="(company$ | async).logo.href"
  [width]="width() ? width() : 236"
  [height]="height() ? height() : 58" />

<!-- Logo placeholder -->
<ic-logo
  *ngIf="!(company$ | async).logo && displayFallbackLogo()"
  [width]="width() ? width() : 236"
  [height]="height() ? height() : 58" />
